import * as React from "react";
import { singleton } from "logic/singleton";
const CurrentUserContext = React.createContext(void 0);
export default singleton("contexts.CurrentUserContext", () => CurrentUserContext);
